module.exports = __webpack_public_path__ + "static/media/tutorial-1.e91db9e9.svg";